export default __webpack_public_path__ + "static/media/australia.41d2fffa.png";